import {useExecuteInView} from '../../../common/useExecuteInView.hook';
import {OperationDayOfWeekCardBanner} from '../../../design-system/organisms/OperationDayOfWeekCardBanner/OperationDayOfWeekCardBanner';
import {BannerItem} from '../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {useGetDayOfWeekEventLog} from '../hook/useGetDayOfWeekEventLog';
import {DayOfWeekLogProps} from '../type';

interface Props {
  columnIndex?: number;
  bannerItem: BannerItem;
  logProps: DayOfWeekLogProps;
}

export const DayOfWeekSectionCardBannerItem = ({
  columnIndex = 0,
  bannerItem,
  logProps,
}: Props) => {
  const {getCustomProps} = useGetDayOfWeekEventLog(logProps);
  const commonCustomProps = getCustomProps();

  const columnOrdnum = String(columnIndex + 1);

  const inViewRef = useExecuteInView({
    callback: () => {
      if (!bannerItem.scheme) return;
      aggregateAndSendLog({
        actionType: 'ViewImp',
        actionName: '배너_노출',
        viewimp_contents: {
          ...BANNER_LOG_CONSTANTS,
          imp_type: 'vimp',
          id: bannerItem.scheme,
          type: 'scheme',
        },
        customProps: {
          user_action: 'imp',
          ...commonCustomProps,
          event_tab_ordnum: columnOrdnum,
        },
      });
    },
  });

  const handleClickBanner = () => {
    if (!bannerItem.scheme) return;
    aggregateAndSendLog({
      actionType: 'Event',
      actionName: '배너_클릭',
      eventMeta: {
        id: bannerItem.scheme,
        type: 'scheme',
        provider: 'service',
      },
      click: BANNER_LOG_CONSTANTS,
      customProps: {
        user_action: 'click',
        ...commonCustomProps,
        event_tab_ordnum: columnOrdnum,
        landing_path: bannerItem.scheme,
      },
    });
  };

  return (
    <div className="mt-2pxr" ref={inViewRef}>
      <OperationDayOfWeekCardBanner
        bannerItem={bannerItem}
        onClick={handleClickBanner}
      />
    </div>
  );
};

const BANNER_LOG_CONSTANTS = {
  imp_id: 'songoing_b',
  imp_provider: 'service',
  layer1: '배너',
} as const;
